@if (news.length > 0) {
  <div class="tech-news-sidebar">
    <div class="tech-news-header">{{ 'sidebar.latestNews' | t }}</div>
    @for (item of news; track item._id) {
      <a class="tech-news-item" [href]="item.link" target="_blank" rel="noopener">
        @if (item.pictureUrl) {
          <img class="tech-news-thumb" [src]="item.pictureUrl" alt="" loading="lazy" referrerpolicy="no-referrer"
            (error)="hidePicture($event)">
        } @else {
          <span class="tech-news-thumb"></span>
        }
        <span class="tech-news-text">
          <span class="tech-news-title">{{ item.title }}</span>
          <span class="tech-news-source">{{ item.sourceName }}</span>
        </span>
      </a>
    }
  </div>
}
